import React from 'react';
import classNames from 'classnames';
import styles from './style.css';
import Dummy from '../Dummy';

export default class Progress extends Dummy {

    render() {
        let progressClass = {};
        let value = this.props.ps;
        let disabled = value.disabled || value.cleaned < this.props.min || value.cleaned > this.props.max;
        let percentage = (value.cleaned - this.props.min) / (this.props.max - this.props.min) * 100;
        progressClass[styles.disabled] = disabled;
        if (disabled) {
            percentage = '?';
        } else {
            percentage = percentage.toFixed(0);
        }
        return (
            <div className={classNames('progress', styles.progress, progressClass)} id={this.props.div_id}>
                <div className="progress-bar " role="progressbar" style={{width: `${percentage}%`}}>
                    <span>{percentage}%</span>
                </div>
            </div>
        );
    }
}

Progress.propTypes = {
    max: React.PropTypes.number,
    min: React.PropTypes.number,
    div_id: React.PropTypes.string,
};




// WEBPACK FOOTER //
// ./src/lib/core/Progress/index.jsx